// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fh66","title":"styles_title__3OcdH"};